export default __webpack_public_path__ + "static/media/silicon-valley.7192fdd6.jpeg";